import { render, staticRenderFns } from "./ModalUpload.vue?vue&type=template&id=a0d74640&scoped=true"
import script from "./ModalUpload.vue?vue&type=script&lang=js"
export * from "./ModalUpload.vue?vue&type=script&lang=js"
import style0 from "./ModalUpload.vue?vue&type=style&index=0&id=a0d74640&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d74640",
  null
  
)

export default component.exports